import { down } from 'styled-breakpoints'
import styled from 'styled-components'
import Modal from 'react-modal'
import ripple from '../../../styles/animations/ripple'
import { darken } from 'polished'

export const ModalComponent = styled(Modal).attrs({
  style: {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
      zIndex: 120,
    },
  },
})`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  overflow: hidden;
  border-radius: 0;
  background: ${({ theme }) => theme.colors.secondary};
  margin: 0;
  display: flex;
  flex-direction: column;
`
export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  overflow: hidden;
`

export const ContentScroll = styled.div`
  max-height: 300px;
  overflow-y: auto;
`

export const Content = styled.div<{ maxWidth?: number; isHovered: boolean }>`
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  justify-content: center;
  gap: 15px;
  height: 300px;
  z-index: 999px;
  margin-bottom: 15px;
  border: 2px dashed ${({ isHovered, theme }) => (isHovered ? theme.colors.primary : '#646464')};
  border-radius: 20px;
`

export const FolderImg = styled.img`
  width: 71.274px;
  height: 60.758px;
`

export const Title = styled.div`
  font-size: 17.526px;
  font-style: normal;
  font-weight: 800;
  text-align: center;
  line-height: normal;
  color: ${({ theme }) => theme.colors.primary};
`

export const SubTitle = styled.div`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 11.684px;
  font-style: normal;
  text-align: center;
  font-weight: 400;
  line-height: normal;
`
export const Button = styled.div`
  ${ripple}
  cursor: pointer;
  border-radius: 23.125px;
  background: ${({ theme }) => darken(-0.6, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.primary};
  padding: 15px 20px;
  font-size: 13.875px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
`

export const ContentBody = styled.div`
  overflow-y: auto;
  max-height: 800px;
`

export const TitleHeader = styled.label`
  font-size: 18px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.title};
`
